import classNames from "classnames";
import React, { ButtonHTMLAttributes, MouseEvent, PropsWithChildren } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { InquiryStatus } from "../../../../domain/inquiry/Inquiry";
import { useBoolean } from "../../../hooks/common/useBoolean";
import InquiryStatusLabel from "./InquiryStatusLabel";

export default function StatusSelector(props: Props) {

    const { currentStatus, handleSelectStatus, ...rest } = props;

    const [isOpen, , close, toggle] = useBoolean(false);

    const allStatus: Statuses = ["NEW", "IN_PROGRESS", "RESOLVED", "CLOSED"];
    const options = allStatus.filter(status => status !== currentStatus);

    const onClickCurrentStatusButton = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        toggle();
    };

    const handleClickStatusSelector = (status: InquiryStatus) => (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        handleSelectStatus(status);
        close();
    };

    return (
        <div className="inquiry_status_selector">
            <OutsideClickHandler onOutsideClick={close}>
                <button onClick={onClickCurrentStatusButton} { ...rest } className="current_status">
                    <InquiryStatusLabel status={currentStatus}/>
                </button>
                <div className={classNames("options", { "open": isOpen })}>
                    { options.map(option => (
                        <button onClick={handleClickStatusSelector(option)} key={option} className="status_button">
                            <InquiryStatusLabel status={option} />
                        </button>
                    ))}
                </div>
            </OutsideClickHandler>
        </div>
    );
}

interface Props extends PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>> {
    currentStatus: InquiryStatus,
    handleSelectStatus: (status: InquiryStatus) => void
}

type Statuses = ["NEW", "IN_PROGRESS", "RESOLVED", "CLOSED"];